// 环境配置文件
const config = {
  // 开发环境
  development: {
    baseURL: 'http://192.168.1.6:8081/test-Shakespeare/server', // 本地开发服务器地址
    // baseURL: 'https://test-shakespeare.solomore.net/server', // 服务器地址
    // baseURL: 'https://test-shakespeare.solomore.net/server', // 测试服务器地址
    timeout: 300000, 
  },
  // 生产环境（后续可以替换为正式环境地址）
  production: {
    // baseURL: 'http://192.168.1.6:8081/Shakespeare/server', // 本地开发服务器地址
    baseURL: 'https://test-shakespeare.solomore.net/server', // 服务器地址
    // baseURL: 'https://test-test-shakespeare.solomore.net/server', // 测试服务器地址
    timeout: 300000, 
  }
}

// 根据当前环境获取配置
const getConfig = () => {
  const env = process.env.NODE_ENV || 'development'
  return config[env]
}

export default getConfig()
